import React from 'react'
import { NavLink } from 'react-router-dom'

import { Nav, Navbar } from 'rsuite'
import { MenuOutline, SettingsOutline, GlobeOutline } from 'react-ionicons'

import { 
  ROUTE_SETTINGS, 
  ROUTE_SETTINGS_MENUS,
  ROUTE_SETTINGS_TOPOLOGY
} from '@@partner:config/routes'

export default function SettingsTopMenu () {
  return (
    <Navbar>
      <Nav>
        <Nav.Item
          icon={<SettingsOutline />}
          as={NavLink}
          to={ROUTE_SETTINGS}
        >
          Общие настройки
        </Nav.Item>
        <Nav.Item
          icon={<MenuOutline />}
          as={NavLink}
          to={ROUTE_SETTINGS_MENUS}
        >
          Управление меню
        </Nav.Item>
        <Nav.Item
          icon={<GlobeOutline />}
          as={NavLink}
          to={ROUTE_SETTINGS_TOPOLOGY}
        >
          Топология
        </Nav.Item>
      </Nav>
    </Navbar>
  )
}
